import React from "react";
import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Checkbox,
	ListItemText,
} from "@mui/material/";
import "../css/Filters.css";

function Filters({
	filters,
	filtersSelected,
	isCheckAllFilters,
	setFiltersSelected,
	setIsCheckAllFilters,
	updateServices,
	showClearAllButton,
}) {
	const filtersHandleChange = (e, filterName) => {
		e.preventDefault();
		if (e.target.value.includes("Select All")) {
			const filtersSelectedTmp = { ...filtersSelected };
			if (isCheckAllFilters[filterName]) {
				filtersSelectedTmp[filterName] = [];
			} else {
				filtersSelectedTmp[filterName] = filters[filterName];
			}

			setFiltersSelected(filtersSelectedTmp);
			const isCheckAllFiltersTmp = {
				...isCheckAllFilters,
			};
			isCheckAllFiltersTmp[filterName] =
				!isCheckAllFiltersTmp[filterName];
			setIsCheckAllFilters(isCheckAllFiltersTmp);
		} else {
			const isCheckAllFiltersTmp = {
				...isCheckAllFilters,
			};
			isCheckAllFiltersTmp[filterName] = false;
			setIsCheckAllFilters(isCheckAllFiltersTmp);

			const filtersSelectedTmp = { ...filtersSelected };
			filtersSelectedTmp[filterName] = e.target.value;
			setFiltersSelected(filtersSelectedTmp);
		}
	};

	const filtersClearAll = () => {
		setFiltersSelected(filters);
		const initialCheckAllState = {};
		Object.keys(filters).forEach((filterName) => {
			initialCheckAllState[filterName] = true;
		});
		setIsCheckAllFilters(initialCheckAllState);
	};

	return (
		<>
			<div className="filters-container">
				{Object.keys(filters).map((filterName) => (
					<FormControl
						id={filterName + "-filter-container"}
						size="small"
						className="filter"
						key={filterName + "-filter-container"}
					>
						<InputLabel
							id={filterName + "-filter-label"}
							style={{
								width: "210px !important",
								paddingRight: "0.8% !important",
							}}
						>
							{filterName}
						</InputLabel>
						<Select
							MenuProps={{ autoFocus: false }}
							labelId={filterName + "-multiple-checkbox-label"}
							id={filterName + "-multiple-checkbox"}
							multiple
							value={filtersSelected[filterName]}
							onChange={(e) => filtersHandleChange(e, filterName)}
							onClose={updateServices}
							label={filterName}
							renderValue={(selected) => {
								selected = selected.filter((n) => n);
								return selected.join(", ");
							}}
						>
							<MenuItem key="Select All" value="Select All">
								<Checkbox
									checked={isCheckAllFilters[filterName]}
								/>
								<ListItemText primary="Select All" />
							</MenuItem>
							{filters[filterName].map((sampleOption) => {
								return (
									<MenuItem
										key={sampleOption}
										value={sampleOption}
									>
										<Checkbox
											checked={
												filtersSelected[
													filterName
												].indexOf(sampleOption) > -1
											}
										/>
										<ListItemText primary={sampleOption} />
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				))}
				{showClearAllButton ? (
					<button
						type="button"
						id="filters_clear_button"
						onClick={filtersClearAll}
					>
						Clear all filters
					</button>
				) : (
					<div className="filter" />
				)}
			</div>
		</>
	);
}

export default Filters;
